import React from 'react';

export default function CheckIcon() {
    return (
        <svg viewBox="0 0 21 16">
            <path d="M20.898 2.999l-12.9 12.9L.1 7.999l2.829-2.828 5.07 5.07L18.07.172z" />
        </svg>
    )
}
